import { render, staticRenderFns } from "./ShowBasic.vue?vue&type=template&id=7d73b59b&"
import script from "./ShowBasic.vue?vue&type=script&lang=ts&"
export * from "./ShowBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports